<template>
    <div>
        
        <!-- Notifications -->

        <!-- The id is shared with the notification widget, because the reading modal of the
             layout listens to that namespace: the state needs a key of its own. -->

        <trax-ui-ajax-data-table
            :id="id+'-table'" :props="props" :endpoint="endpoint" :endpoint-params="endpointParams"
            :header="header" :paging="paging" :searching="searching" :bus="bus"
            :empty-message="lang.polaris.notification.no_notification"
            state-key="trax-notification-others"
            :selectable="true" v-model="selection"
            ref="notifications"
        >
            <div class="ml-2 mt-3">
                <button type="button" class="btn btn-danger btn-sm mr-2" @click="deleteAll"> {{ lang.polaris.form.delete_all }} </button>
                <button v-if="selection.length" type="button" class="btn btn-danger btn-sm" @click="deleteSelection"> {{ lang.polaris.form.delete_selection }} </button>
            </div>
        </trax-ui-ajax-data-table>
        
        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="this.lang.polaris.notification.delete_notifications" :bus="bus">
            {{ lang.polaris.notification.delete_notifications_confirm }}
        </trax-ui-modal-confirm>

    </div>

</template>

<script>
    export default {
    
        props: {
            id: { default: 'trax-notification' },
            header: { default: 0 },
            paging: { default: 1 },
            searching: { default: 1 },
        },

        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                endpoint: app_url+"polaris/api/front/notifications",
                endpointParams: {
                    sort: ['-id'],
                    filters: {
                        'data->type': 'sheet'
                    }
                },
                props: [
                    {source: this.preview, orderable: false },
                ],
                notifications: {},
                selection: [],
                deleteParams: {},
                bus: this.$bus
            }
        },

        created: function() {
            this.bus.$on(this.id+'-notification-deleted', this.deleted);
            this.bus.$on(this.id+'-notification-read', this.read);
            this.bus.$on(this.id+'-delete-confirmed', this.deleteNow);
        },

        mounted: function() {
            var that = this;
            $('#'+this.id+'-table-table tbody').on( 'click', '.notification-link', function(event) {
                that.open($(this).attr('data-id'));
            });

        },

        methods: {

            deleteAll() {
                this.deleteParams = {params: {type: 'sheet'}}
                this.bus.$emit(this.id+'-delete-open');
            },
        
            deleteSelection() {
                this.deleteParams = {params: {type: 'sheet', ids: this.selection}}
                this.bus.$emit(this.id+'-delete-open');
            },
        
            deleteNow() {
                axios.delete(
                    this.app_url+"polaris/api/front/my-notifications",
                    this.deleteParams
                )
                .then(response => {
                    this.$refs.notifications.refresh();
                })
                .catch(error => {
                });
            },
        
            preview(data, type, row, meta) {
                this.notifications[row.id] = row;
                var res = '';
                if (!row.read) res += '<span class="badge badge-danger float-right ml-1">'+this.lang.polaris.notification.new+'</span>';
                res += '<span class="font-weight-bold">'+this.trans(row.data.content.title)+'<span>';
                res += '<br><small class="font-weight-light">'+moment(row.created_at).format('DD MMM YYYY')+'</small>';
                return '<div class="notification-link" style="cursor:pointer" data-id="'+row.id+'">'+res+'</div>';
            },

            open(id) {
                var notification = this.notifications[id];
                var title = this.trans(notification.data.content.title);
                this.bus.$emit(this.id+'-modal-open', { headerColor: 'danger', icon: 'notifications', title: title, data: notification });
            },

            deleted(id) {
                this.bus.$emit(this.id+'-table-refresh', id);
            },

            read(id) {
                $('#'+this.id+'-table-table tbody .notification-link[data-id='+id+'] .badge').hide();
            },

            trans(key) {
                return this.lang.polaris.notification[key.split('.').pop()]
            }
        }
    }
</script>
